// Central site data — Ukrainian content for Dr. Tetiana Zolotko's luxury clinic.

export const doctor = {
  name: "Tetiana Zolotko",
  nameUa: "Тетяна Золотько",
  title: "Лікар терапевт-косметолог",
  subtitle: "Wellness & Anti-age спеціалістка",
  phones: ["+38 (066) 931-74-13", "+38 (098) 116-87-42"],
  phonesRaw: ["0669317413", "0981168742"],
  telegram: "https://t.me/Queen150785",
  telegramHandle: "@Queen150785",
  email: "ms.ukrzolotko5777@gmail.com",
  instagram: "https://instagram.com/tetiana_zolotko",
  address: "пр-т Соборності 17, корпус 2, під'їзд 24, кв. 1753, Київ, Україна",
  addressShort: "пр-т Соборності 17, к. 2, Київ",
  mapsQuery: "пр-т Соборності 17 корпус 2 Київ",
  mapsLink:
    "https://www.google.com/maps/dir/?api=1&destination=" +
    encodeURIComponent("пр-т Соборності 17 корпус 2, Київ"),
  photos: {
    portrait1: "/doctor/portrait1.webp",
    portrait2: "/doctor/portrait2.webp",
    portrait3: "/doctor/portrait3.webp",
    clinicDesk: "/doctor/clinic_desk.webp",
    gloves: "/doctor/gloves.webp",
  },
};

export const stockImages = {
  clinicInterior:
    "https://images.pexels.com/photos/31844508/pexels-photo-31844508.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  injection:
    "https://images.unsplash.com/photo-1746017062285-13c77e29fc25?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxhZXN0aGV0aWMlMjBjb3NtZXRvbG9neSUyMGluamVjdGlvbnxlbnwwfHx8fDE3NzkwMzM4OTR8MA&ixlib=rb-4.1.0&q=85",
  wellness:
    "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxzcGElMjB3ZWxsbmVzcyUyMHRoZXJhcHl8ZW58MHx8fHwxNzc5MDMzODkwfDA&ixlib=rb-4.1.0&q=85",
  dermatology:
    "https://images.unsplash.com/photo-1730288951113-9cc087c14b83?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxkZXJtYXRvbG9neSUyMGZhY2lhbCUyMHRyZWF0bWVudHxlbnwwfHx8fDE3NzkwMzM4OTB8MA&ixlib=rb-4.1.0&q=85",
};

export const serviceCategories = [
  {
    slug: "injection",
    title: "Інʼєкційна косметологія",
    subtitle: "Anti-age, гармонізація, корекція форми",
    cover: "/generated/procedure.webp",
    fallback: stockImages.injection,
    sections: [
      {
        title: "BOTULINOTHERAPY",
        items: [
          { name: "Лоб + міжбрівка", price: "4 500 грн" },
          { name: "Міжбрівка", price: "2 700 грн" },
          { name: "Очі", price: "2 700 грн" },
          { name: "Лоб + міжбрівка + очі", price: "6 500 грн" },
          { name: 'Ніс ("зморшки кролика")', price: "1 500 грн" },
          { name: "Звуження носа", price: "2 700 грн" },
          { name: "Підняття кінчика носа", price: "2 700 грн" },
          { name: "Підняття брів", price: "2 700 грн" },
          { name: "Підборіддя", price: "2 700 грн" },
          { name: "Бруксизм (жувальні мʼязи)", price: "6 000 грн" },
          { name: "Кисетні зморшки", price: "8 000 грн" },
          { name: 'Ліфтинг "Ніфертіті" (плазма шиї)', price: "8 000 грн" },
          { name: "Точка голоду", price: "4 000 грн" },
          { name: "Підпашки / долоні 100 од.", price: "10 500 грн" },
          { name: "Розслаблення трапеції", price: "10 500 грн" },
          { name: "Full Face 120–130 од.", price: "14 500 грн" },
        ],
      },
      {
        title: "BIOREVITALIZATION / MESOTHERAPY",
        items: [
          { name: 'Коктейль "Монако" (обличчя)', price: "7 000 грн" },
          { name: 'Коктейль "Монако" (обличчя + шия + декольте)', price: "12 000 грн" },
          { name: "Filler Vit R (амінокислотний комплекс) 4,5 мл", price: "3 500 грн" },
          { name: "Filler Vit R 9 мл", price: "6 000 грн" },
          { name: "TwAc 2.0", price: "11 000 грн" },
          { name: "TwAc 3.0", price: "12 000 грн" },
          { name: "TwAc Eyes", price: "5 000 грн" },
          { name: "Belotero Soft (кільця Венери)", price: "12 000 грн" },
          { name: "ПДРН Plenhyage XL Strong (Італія)", price: "13 000 грн" },
        ],
      },
      {
        title: "Губи",
        items: [
          { name: "Stylage M 1 ML", price: "8 500 грн" },
          { name: "Aileene 1,1 ML", price: "7 500 грн" },
          { name: "Примірка губ", price: "2 500 грн" },
          { name: "Розчинення губ", price: "2 700 грн" },
        ],
      },
      {
        title: "Контурна пластика обличчя Full Face",
        items: [
          { name: "Aileene 1 ML", price: "7 500 грн" },
          { name: "Aileene 2 ML", price: "14 000 грн" },
          { name: "Aileene 3 ML", price: "19 000 грн" },
          { name: "Aileene 4 ML", price: "25 000 грн" },
          { name: "Aileene 5 ML", price: "30 000 грн" },
        ],
      },
      {
        title: "Носослізка",
        items: [
          { name: "Teosyal RH2", price: "13 000 грн" },
          { name: "Plinage XXL Strong", price: "13 000 грн" },
        ],
      },
    ],
  },
  {
    slug: "weight",
    title: "Терапія та супровід по схудненню",
    subtitle: "Медична програма корекції ваги",
    cover: "/generated/weight_loss.webp",
    fallback: stockImages.wellness,
    weightProgram: {
      lead: "Комплексний підхід до зниження ваги під наглядом лікаря-терапевта.",
      includesTitle: "Що входить",
      includes: [
        "Первинна консультація лікаря",
        "Аналіз вашого стану здоровʼя та харчових звичок",
        "Рекомендації щодо необхідних аналізів",
        "Індивідуальний план зниження ваги",
        "Підбір терапії за показаннями",
        "Супровід та корекція рекомендацій під час програми",
      ],
      programPrice: "5 000 грн",
      programPriceLabel: "Вартість первинної консультації та старту програми",
      medicalProgram: {
        title: "Медична програма корекції ваги",
        description:
          "Метод терапії визначається індивідуально після консультації, оцінки аналізів, показань і протипоказань. Програма передбачає рекомендації лікаря та подальший контроль результатів.",
        ctaLabel: "Записатися на консультацію",
      },
    },
    items: [
      "Консультація по зниженню ваги",
      "Індивідуальний супровід пацієнтів",
      "Робота з харчовою поведінкою",
      "Індивідуальна медична терапія за показаннями",
      "Контроль аналізів та стану здоровʼя",
      "Медичний супровід під час зниження ваги",
      "Робота з дефіцитами",
      "Відновлення метаболізму",
    ],
  },
  {
    slug: "drips",
    title: "Крапельниці та Wellness-терапія",
    subtitle: "Енергія, детокс, краса зсередини",
    cover: "/generated/wellness_drip.webp",
    fallback: stockImages.wellness,
    items: [
      "Вітамінні крапельниці",
      "Детокс-терапія",
      "Anti-stress терапія",
      "Крапельниці для енергії та відновлення",
      "Імунна підтримка",
      "Крапельниці для покращення стану шкіри",
      "Метаболічна підтримка",
    ],
  },
  {
    slug: "laser",
    title: "Апаратна косметологія",
    subtitle: "Лазерні та anti-age технології",
    cover: "/generated/apparatus_cover.webp",
    fallback: stockImages.dermatology,
    items: [
      "Лазерне RF омолодження",
      "Лазерне RF видалення волосся (в тому числі світле, пушкове, руде)",
      "Лазерне RF лікування акне",
      "Трихоскопія",
    ],
    sections: [
      {
        title: "Омолодження · пакети",
        items: [
          { name: "Обличчя", price: "2 000 грн", coursePrice: "1 500 грн" },
          { name: "Обличчя + шия", price: "2 500 грн", coursePrice: "2 000 грн" },
          { name: "Обличчя, шия, декольте", price: "3 000 грн", coursePrice: "2 500 грн" },
          { name: "Руки", price: "2 000 грн", coursePrice: "1 500 грн" },
        ],
      },
      {
        title: "Лікування акне · пакети",
        items: [
          { name: "Обличчя", price: "2 000 грн", coursePrice: "1 500 грн" },
          { name: "Обличчя + шия", price: "2 500 грн", coursePrice: "2 000 грн" },
          { name: "Обличчя, шия, декольте", price: "3 000 грн", coursePrice: "2 500 грн" },
          { name: "Спина", price: "3 000 грн", coursePrice: "2 500 грн" },
        ],
      },
    ],
    hasLaserEpilation: true,
  },
  {
    slug: "aesthetic",
    title: "Естетична та доглядова косметологія",
    subtitle: "Сяйво, чистота, доглянутість",
    cover: "/generated/aesthetic_cover.webp",
    fallback: stockImages.clinicInterior,
    sections: [
      {
        title: "Доглядові процедури",
        items: [
          { name: "Вогонь та лід: обличчя (40 хв)", price: "3 000 грн" },
          { name: "Вогонь та лід: обличчя + шия + декольте (50 хв)", price: "3 500 грн" },
          { name: "Чиста шкіра: обличчя", price: "2 000 грн" },
          { name: "Чиста шкіра: обличчя + шия", price: "2 500 грн" },
          { name: "Комбінована чистка обличчя з маскою та поверхневим пілінгом", price: "2 500 грн" },
          { name: "Поверхневий пілінг", price: "1 500 грн" },
          { name: "Пілінг поверхневий Apeex", price: "2 500 грн" },
          { name: "Пілінг серединний Apeex", price: "3 500 грн" },
          { name: "Пілінг серединний IS Clinical", price: "4 000 грн" },
        ],
      },
    ],
  },
];

export const laserEpilation = {
  brandLine: "Tetiana Zolotko Beauty Studio",
  tagline: "Нова технологія • Максимальний результат",
  zones: [
    {
      title: "Інтимна зона",
      icon: "intimate",
      items: [
        { name: "Пахви", female: "600 грн", male: "800 грн" },
        { name: "Бікіні класичне", female: "800 грн", male: "1 100 грн" },
        { name: "Бікіні повне", female: "1 100 грн", male: "1 900 грн" },
        { name: "Лобок", female: "800 грн", male: "1 200 грн" },
        { name: "Міжсіднична складка", female: "700 грн", male: "1 000 грн" },
        { name: "Статеві губи", female: "600 грн" },
        { name: "Сідниці", female: "1 000 грн", male: "1 500 грн" },
      ],
    },
    {
      title: "Ноги",
      icon: "legs",
      items: [
        { name: "Ноги повністю", female: "1 800 грн", male: "2 900 грн" },
        { name: "Ноги до коліна", female: "1 100 грн", male: "1 800 грн" },
        { name: "Стегна", female: "900 грн", male: "1 600 грн" },
        { name: "Гомілки", female: "900 грн", male: "1 600 грн" },
      ],
    },
    {
      title: "Руки",
      icon: "arms",
      items: [
        { name: "Руки повністю", female: "1 300 грн", male: "1 700 грн" },
        { name: "Руки до ліктя", female: "800 грн", male: "1 200 грн" },
        { name: "Передпліччя", female: "800 грн", male: "1 200 грн" },
      ],
    },
    {
      title: "Обличчя",
      icon: "face",
      items: [
        { name: "Все обличчя", female: "1 000 грн", male: "1 300 грн" },
        { name: "Верхня губа", female: "350 грн", male: "500 грн" },
        { name: "Підборіддя", female: "350 грн", male: "500 грн" },
        { name: "Щоки", female: "500 грн", male: "700 грн" },
        { name: "Міжбрівʼя", female: "350 грн", male: "500 грн" },
        { name: "Шия", female: "800 грн", male: "1 100 грн" },
      ],
    },
    {
      title: "Спина та живіт",
      icon: "back",
      items: [
        { name: "Верх спини + плечі", female: "1 200 грн", male: "1 700 грн" },
        { name: "Живіт", female: "800 грн", male: "1 000 грн" },
        { name: "Спина повністю", female: "1 800 грн", male: "2 700 грн" },
      ],
    },
  ],
  promoPackages: [
    { name: "Пахви + глибоке бікіні", price: "1 300 грн", oldPrice: "1 800 грн" },
    { name: "Пахви + глибоке бікіні + ноги до коліна", price: "2 400 грн", oldPrice: "2 900 грн" },
    { name: "Пахви + глибоке бікіні + ноги повністю", price: "2 700 грн", oldPrice: "3 600 грн" },
  ],
  fullBody: [
    { name: "Жінки", price: "5 500 грн", oldPrice: "7 200 грн" },
    { name: "Чоловіки", price: "7 500 грн", oldPrice: "9 800 грн" },
  ],
  benefits: [
    "Ефективно на будь-якому типі волосся та шкіри",
    "Працює зі світлим, рудим та темним волоссям",
    "Сучасна лазерна технологія нового покоління",
    "Комфортна процедура з системою охолодження",
    "Мінімальний дискомфорт під час процедури",
    "Швидке проведення сеансу",
    "Безпечна процедура для різних фототипів шкіри",
    "Видимий результат вже після перших процедур",
    "Преміальна якість обладнання",
    "Індивідуальний підбір параметрів для кожного клієнта",
  ],
  slogan: "Гладенька шкіра — твоя впевненість щодня!",
};

export const academyTracks = [
  {
    slug: "injection",
    title: "Навчання інʼєкційним методикам",
    items: [
      "Контурна пластика губ",
      "Контурна пластика обличчя (Full Face)",
      "Біоревіталізація",
      "Біостимуляція",
      "Мезотерапія",
      "Ліполітики",
      "Нитковий ліфтинг",
      "Постановка руки для початківців",
      "Авторські протоколи роботи",
      "Підвищення кваліфікації для косметологів",
      "Індивідуальне навчання",
    ],
  },
  {
    slug: "weight",
    title: "Навчання по терапії зниження ваги",
    items: [
      "Робота з пацієнтами на медичній програмі корекції ваги",
      "Медичний супровід пацієнтів",
      "Розбір аналізів перед терапією",
      "Контроль дефіцитів та станів",
      "Алгоритми ведення пацієнтів",
      "Побудова індивідуальних схем супроводу",
    ],
  },
  {
    slug: "drips",
    title: "Навчання по крапельній терапії",
    items: [
      "Вітамінні крапельниці",
      "Детокс-терапія",
      "Метаболічна підтримка",
      "Відновлюючі протоколи",
      "Безпечне введення препаратів",
      "Протоколи підтримки пацієнтів",
    ],
  },
];

export const consultations = [
  "Консультація лікаря терапевта-косметолога",
  "Онлайн консультація",
  "Підбір домашнього догляду",
  "Розбір аналізів",
  "Індивідуальні протоколи догляду",
];

export const certificates = [
  {
    src: "/certificates/cert_biopell.webp",
    title: "BIOPELL Medical · ISO 9001",
    description: "Clinical specialist — bioidentical pellets implantation",
    year: "2025 — 2030",
  },
  {
    src: "/certificates/cert_medicalaser.webp",
    title: "European Academy of Laser Technology",
    description: "Advanced diploma · Happy-Light Duet plus",
    year: "Medicalaser Diploma",
  },
  {
    src: "/certificates/cert_beskinny.webp",
    title: "BeSkinny by Vitalina Grositska",
    description: "Lip & Full Face contouring · Botulin therapy",
    year: "Certificate",
  },
  {
    src: "/certificates/cert_sapphirelift.webp",
    title: "Aesthetichna Gurtivnya",
    description: "Тредліфтинг · армування тканин мезонитками",
    year: "Сертифікат",
  },
  {
    src: "/certificates/cert_isclinical.webp",
    title: "iS Clinical · BMED",
    description: "Косметецевтика — теоретичний та практичний курс",
    year: "Серпень 2021",
  },
];

export const testimonials = [
  {
    name: "Анна К.",
    location: "Київ",
    quote:
      "Тетяна — справжній професіонал. Контурна пластика губ виглядає природно, навіть моя мама не помітила підправлень. Дуже делікатний підхід.",
  },
  {
    name: "Олена М.",
    location: "Київ",
    quote:
      "За пів року супроводу по схудненню втратила 14 кг. Жодного стресу — лише підтримка, аналізи та грамотна корекція. Низький уклін.",
  },
  {
    name: "Юлія С.",
    location: "Дніпро",
    quote:
      "Вітамінні крапельниці — мій ритуал перед важливими подіями. Шкіра світиться, сили на максимумі. Атмосфера в кабінеті — як у дорогому готелі.",
  },
  {
    name: "Ірина П.",
    location: "Одеса",
    quote:
      "Після курсу біоревіталізації шкіра стала щільнішою та сяючою. Доктор пояснює кожен крок — почуваєш себе в безпеці.",
  },
  {
    name: "Катерина Л.",
    location: "Львів",
    quote:
      "Пройшла навчання інʼєкційним методикам — це найкращі інвестиції в карʼєру. Авторські протоколи, постановка руки, відповіді на всі питання.",
  },
  {
    name: "Марія Д.",
    location: "Київ",
    quote:
      "Лазерне видалення пігментації змінило моє обличчя. Ніколи не думала, що це можливо так делікатно і безпечно.",
  },
];

export const blogPosts = [
  {
    slug: "anti-age-strategy",
    title: "Anti-age стратегія: з чого почати після 30",
    excerpt:
      "Чому раннє anti-age — не про філери, а про якість шкіри, гідратацію та внутрішні процеси. Розкладаю по поличках.",
    cover: stockImages.dermatology,
    date: "12 грудня 2025",
    readTime: "6 хв",
  },
  {
    slug: "weight-truth",
    title: "Медична корекція ваги — без міфів",
    excerpt:
      "Як працює медична програма зниження ваги, кому вона показана, а кому ні, і чому потрібен медичний супровід.",
    cover: "/generated/weight_program_blog.webp",
    fallback: stockImages.wellness,
    date: "5 грудня 2025",
    readTime: "9 хв",
  },
  {
    slug: "drips-energy",
    title: "Вітамінні крапельниці: ритуал чи терапія?",
    excerpt:
      "Розбираю популярні протоколи — детокс, енергія, краса шкіри. Що працює, а що — маркетинг.",
    cover: "/generated/wellness_drip.webp",
    fallback: stockImages.wellness,
    date: "28 листопада 2025",
    readTime: "5 хв",
  },
  {
    slug: "lip-contouring",
    title: "Природні губи: філософія делікатної контурної пластики",
    excerpt:
      "Як виглядати освіжено, а не «зробленою». Авторський підхід до контурної пластики, який обирають моделі та публічні особи.",
    cover: stockImages.injection,
    date: "20 листопада 2025",
    readTime: "7 хв",
  },
];

export const beforeAfter = [
  {
    title: "Контурна пластика губ",
    caption: "Природний обʼєм та чітка форма за одну процедуру.",
    image: "/before-after/case1_lips.webp",
  },
  {
    title: "Ліполітики для підборіддя",
    caption: "Результат зменшення підборіддя після 3 процедур ліполітиків.",
    image: "/before-after/case2_chin.webp",
  },
];

export const navLinks = [
  { to: "/", label: "Головна" },
  { to: "/about", label: "Про мене" },
  { to: "/services", label: "Послуги" },
  { to: "/before-after", label: "До / Після" },
  { to: "/license", label: "Ліцензія МОЗ" },
  { to: "/certificates", label: "Сертифікати" },
  { to: "/academy", label: "Навчання" },
  { to: "/consultations", label: "Консультації" },
  { to: "/testimonials", label: "Відгуки" },
  { to: "/blog", label: "Блог" },
  { to: "/contacts", label: "Контакти" },
];

export function countCategoryItems(cat) {
  let n = 0;
  if (Array.isArray(cat.items)) n += cat.items.length;
  if (Array.isArray(cat.sections)) {
    for (const s of cat.sections) n += (s.items?.length || 0);
  }
  if (cat.hasLaserEpilation) {
    for (const z of laserEpilation.zones) n += z.items.length;
    n += laserEpilation.promoPackages.length + laserEpilation.fullBody.length;
  }
  return n;
}
